import { cn } from '@antimatterhq/ui/lib/utils';
import { FormCodeEditorProps } from '../../code/FormCodeEditor';
import { FormCodeEditor } from '@/components/form/form';

export type FormSqlExpressionInputProps = FormCodeEditorProps;

export const FormSqlExpressionInput = ({
  name,
  className,
  placeholder = 'E.g. concat(column_name, column_name2)',
  ...props
}: FormSqlExpressionInputProps) => {
  return (
    <FormCodeEditor
      name={name}
      placeholder={placeholder}
      className={cn('min-h-[40px] max-w-form', className)}
      hideControls
      {...props}
    />
  );
};
